// PageHeaderReportView Component

import PropTypes from 'prop-types'
import _ from 'lodash'

import PageHeaderBase from '../../../common/layout/page_header_base/page_header_base.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'

class PageHeaderReportView extends PageHeaderBase {
  static get propTypes () {
    return {
      title: PropTypes.string,
      reportType: PropTypes.string,
      onChangeFilter: PropTypes.func,
      onSearchContact: PropTypes.func,
      onSearchTag: PropTypes.func,
      onSearchProject: PropTypes.func,
      onSearchUser: PropTypes.func,
      onExport: PropTypes.func,
      reportInfo: PropTypes.object,
      showExport: PropTypes.bool,
      isPlannerAllowed: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      reportType: '',
      onChangeFilter: null,
      onSearchContact: null,
      onSearchTag: null,
      onSearchProject: null,
      onSearchUser: null,
      onExport: null,
      reportInfo: null,
      showExport: true,
      isPlannerAllowed: false
    }
  }

  constructor (props) {
    super(props)

    const filter = this.props.filter || null
    this.data = {
      contactOptions: [],
      tagOptions: [],
      projectOptions: [],
      userOptions: [],
      workInProgress: {
        keywordContact: '',
        keywordTag: '',
        contact: null,
        dateFilter: null,
        tags: []
      },
      closedProjects: {
        keywordContact: '',
        keywordTag: '',
        contact: null,
        dateFilter: null,
        tags: []
      },
      employeeProductivity: {
        status: '',
        dateFilter: null
      },
      closedProjectsV2: {
        keywordContact: '',
        keywordTag: '',
        contact: null,
        dateFilter: null,
        tags: []
      },
      employeeProductivityV2: {
        keywordProject: '',
        keywordUser: '',
        keywordContact: '',
        keywordTag: '',
        project: null,
        users: [],
        contact: null,
        dateFilter: null,
        tags: [],
        fromDate: null,
        toDate: null,
        filterType: 'week'
      },
      timeRegistration: {
        keywordContact: '',
        keywordProject: '',
        keywordUser: '',
        keywordTag: '',
        user: null,
        project: null,
        contact: null,
        dateFilter: null,
        tags: []
      },
      plannerOverview: {
        keywordContact: '',
        keywordUser: '',
        keywordTag: '',
        users: [],
        contact: null,
        tags: [],
        fromDate: null,
        toDate: null,
        filterType: 'half-year',
        startMonth: 0,
        startWeekNo: 1,
        year: DateUtil.getLocalYear()
      }
    }

    // Init data from pagestate
    this._initDataFromPageState(filter)

    this.state = {
      currentPanel:
        this._hasActiveFilter() &&
        props.reportType !== 'employee-productivity-v2'
          ? 'filtermain'
          : 'main',
      isFilterActive: false
    }

    this._searchTimeContact = null
    this._searchTimeProject = null
    this._searchTimeUser = null
    this._searchTimeTag = null
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    const filter = nextProps.filter || null

    // Init data from pagestate
    this._initDataFromPageState(filter)

    if (this.state.currentPanel === 'main' && !this.state.isFilterActive) {
      if (
        this._hasActiveFilter() &&
        nextProps.reportType !== 'employee-productivity-v2'
      ) {
        this.state.currentPanel = 'filtermain'
      }
    }
  }

  renderContent () {
    switch (this.state.currentPanel) {
      case 'filtermain':
        return this._renderFilterMain()
      case 'filtercontact':
        return this._renderFilterContact()
      case 'filterdate':
        return this._renderFilterDate()
      case 'filtertag':
        return this._renderFilterTag()
      case 'filteremployee-status':
        return this._renderFilterEmployeeStatus()
      case 'filterdaterange':
        return this._renderFilterDateRange()
      case 'filterproject':
        return this._renderFilterProject()
      case 'filteruser':
        return this._renderFilterUser()
      case 'filterusermulti':
        return this._renderFilterUserMulti()
      default:
        return this._renderPanel()
    }
  }

  getClassName () {
    if (this.props.reportType === 'closed-projects-v2') {
      return this.state.currentPanel !== 'main' ? 'showfilter' : 'closedproject'
    } else if (this.props.reportType === 'employee-productivity-v2') {
      const className = this.props.isPlannerAllowed
        ? 'productivity'
        : 'productivity hasnormal'
      return this.state.currentPanel !== 'main' ? 'showfilter' : className
    } else if (this.props.reportType === 'planner-overview') {
      return this.state.currentPanel !== 'main' ? 'showfilter' : 'planner'
    }

    return this.state.currentPanel !== 'main' ? 'showfilter' : ''
  }

  onEscKeyDown () {
    if (this.state.currentPanel === 'filtermain') {
      this.setState({ currentPanel: 'main' })
    } else if (this.state.currentPanel !== 'main') {
      this.setState({ currentPanel: 'filtermain' })
    }
  }

  /* Private functions */
  _renderPanel () {
    if (this.props.reportType === 'closed-projects-v2') {
      return this._renderClosedProjectMainPanel()
    } else if (this.props.reportType === 'employee-productivity-v2') {
      return this._renderProductivityMainPanel()
    } else if (this.props.reportType === 'planner-overview') {
      return this._renderPlannerMainPanel()
    } else {
      return this._renderMainPanel()
    }
  }

  _renderClosedProjectMainPanel () {
    const _onExport = this._onExport.bind(this)
    let actions = []
    if (this.props.showExport) {
      actions = [
        {
          ident: 'export',
          icon: 'header-download',
          size: 'big',
          canHover: false,
          onClick: _onExport,
          tooltip: 'report.view.tipDownloadReport',
          tooltipPosition: 'bottom'
        }
      ]
    }

    const options = {
      title: IntlUtil.convertMessage('report.view.titleClosedProject'),
      titleInfo: null,
      hasFilter: true,
      hasSearch: false,
      hasEdit: false,
      actions: actions,
      onShowSearch: null,
      onShowFilter: this._onShowFilter.bind(this, 'filtermain'),
      rightInfo: null,
      info: this.props.reportInfo.info,
      isPlannerAllowed: this.props.isPlannerAllowed
    }

    return this.renderClosedProjectMainPanel(options)
  }

  _renderProductivityMainPanel () {
    const _onExport = this._onExport.bind(this)
    let actions = []
    if (this.props.showExport) {
      actions = [
        {
          ident: 'export',
          icon: 'header-download',
          size: 'big',
          canHover: false,
          onClick: _onExport,
          tooltip: 'report.view.tipDownloadReport',
          tooltipPosition: 'bottom'
        }
      ]
    }
    const filter = this.data.employeeProductivityV2
    const options = {
      title: IntlUtil.convertMessage('report.view.titleEmployeeProductivity'),
      titleInfo: null,
      hasFilter: true,
      hasSearch: false,
      hasEdit: false,
      actions: actions,
      onShowSearch: null,
      onShowFilter: this._onShowFilter.bind(this, 'filtermain'),
      rightInfo: null,
      info: this.props.reportInfo.info,
      filterTypes: [
        { label: 'report.header.showTypeHalfyear', value: 'half-year' },
        { label: 'report.header.showTypeWeek', value: 'week' }
      ],
      filterType: filter.filterType,
      fromDate: new Date(filter.fromDate),
      toDate: new Date(filter.toDate),
      graphFromDate: new Date(filter.graphFromDate),
      graphToDate: new Date(filter.graphToDate),
      onChangeFilter: this._onChangeEmpProductivityFilter.bind(this)
    }

    if (this.props.isPlannerAllowed) {
      return this.renderProductivityMainPanel(
        options,
        this.props.isPlannerAllowed
      )
    }

    return this.renderProductivityNormalHeader(
      options,
      this.props.isPlannerAllowed
    )
  }

  _renderPlannerMainPanel () {
    const filter = this.data.plannerOverview
    const options = {
      title: IntlUtil.convertMessage('report.view.titlePlanner'),
      titleInfo: null,
      hasFilter: true,
      hasSearch: false,
      hasEdit: false,
      actions: [],
      onShowSearch: null,
      onShowFilter: this._onShowFilter.bind(this, 'filtermain'),
      rightInfo: null,
      filterTypes: [
        { label: 'report.header.showTypeHalfyear', value: 'half-year' },
        { label: 'report.header.showTypeWeek', value: 'week' }
      ],
      filterType: filter.filterType,
      startMonth: filter.startMonth,
      startWeekNo: filter.startWeekNo,
      startDate: new Date(filter.fromDate),
      year: filter.year,
      onChangeFilter: this._onChangePlannerFilter.bind(this)
    }

    return this.renderPlannerMainPanel(options)
  }

  _renderMainPanel () {
    const _onExport = this._onExport.bind(this)
    const { title } = this.props
    let actions = []
    if (this.props.showExport) {
      actions = [
        {
          ident: 'export',
          icon: 'header-download',
          size: 'big',
          canHover: false,
          onClick: _onExport,
          tooltip: 'report.view.tipDownloadReport',
          tooltipPosition: 'bottom'
        }
      ]
    }

    const options = {
      title: title,
      titleInfo: null,
      hasFilter: true,
      hasSearch: false,
      hasEdit: false,
      onShowSearch: null,
      onShowFilter: this._onShowFilter.bind(this, 'filtermain'),
      rightInfo: null,
      actions: actions
    }

    return this.renderMainPanel(options)
  }

  _renderFilterMain () {
    const currFilter = this._getCurrentFilter()
    const tags = currFilter.tags || []
    const { reportType } = this.props
    const options = {
      info: 'report.view.filterInfo',
      items: [],
      onShowFilter: this._onShowFilter.bind(this),
      onDeleteFilter: this._onDeleteFilter.bind(this),
      onClose: this._onShowFilter.bind(this, 'main')
    }

    if (reportType !== 'planner-overview') {
      options.actions = [
        {
          ident: 'export',
          icon: 'header-download',
          size: 'big',
          canHover: false,
          tooltip: 'contact.list.tipExport',
          tooltipPosition: 'bottom',
          onClick: this._onExport.bind(this)
        }
      ]
    }

    if (
      reportType === 'closed-projects' ||
      reportType === 'closed-projects-v2'
    ) {
      options.items = [
        { type: 'label', label: 'report.view.headerTitleClosedProjects' },
        {
          type: 'date',
          ident: 'filterdaterange',
          label: 'report.view.filterThisMonth',
          value: currFilter.dateFilter,
          isDateRange: true
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'option',
          ident: 'filtercontact',
          label: 'report.view.filterAllClients',
          value: currFilter.contact ? currFilter.contact.label : null
        },
        { type: 'label', label: 'report.view.taggedWith' },
        {
          type: 'options',
          ident: 'filtertag',
          label: 'report.view.filterAllTags',
          value: tags ? tags.map(tag => tag.label) : []
        }
      ]
    } else if (reportType === 'employee-productivity') {
      options.items = [
        { type: 'label', label: 'report.view.headerTitleEmployeeProductivity' },
        {
          type: 'option',
          ident: 'filteremployee-status',
          label: 'report.view.filterAll',
          value: currFilter.status !== 'all' ? currFilter.status : ''
        },
        { type: 'label', label: 'report.view.employeesFor' },
        {
          type: 'date',
          ident: 'filterdaterange',
          label: 'report.view.filterThisMonth',
          value: currFilter.dateFilter,
          isDateRange: true
        }
      ]
    } else if (reportType === 'employee-productivity-v2') {
      options.items = [
        { type: 'label', label: 'report.view.hoursFor' },
        {
          type: 'options',
          ident: 'filterusermulti',
          label: 'report.view.filterAllTeamMembers',
          value: currFilter.users
            ? currFilter.users.map(user => user.label)
            : []
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'option',
          ident: 'filterproject',
          label: 'report.view.filterProjects',
          value: currFilter.project ? currFilter.project.label : null
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'date',
          ident: 'filterdaterange',
          label: 'report.view.filterThisMonth',
          value: currFilter.dateFilter,
          isDateRange: true
        },
        { type: 'label', label: 'report.view.filterOf' },
        {
          type: 'option',
          ident: 'filtercontact',
          label: 'report.view.filterClients',
          value: currFilter.contact ? currFilter.contact.label : null
        },
        { type: 'label', label: 'report.view.taggedWith' },
        {
          type: 'options',
          ident: 'filtertag',
          label: 'report.view.filterTags',
          value: tags ? tags.map(tag => tag.label) : []
        }
      ]
    } else if (reportType === 'time-registration') {
      options.items = [
        { type: 'label', label: 'report.view.headerTitleTimeRegistration' },
        {
          type: 'option',
          ident: 'filteruser',
          label: 'report.view.filterAllTeamMembers',
          value: currFilter.user ? currFilter.user.label : null
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'option',
          ident: 'filterproject',
          label: 'report.view.filterAllProjects',
          value: currFilter.project ? currFilter.project.label : null
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'date',
          ident: 'filterdaterange',
          label: 'report.view.filterThisMonth',
          value: currFilter.dateFilter,
          isDateRange: true
        },
        { type: 'label', label: 'report.view.filterOf' },
        {
          type: 'option',
          ident: 'filtercontact',
          label: 'report.view.filterAllClients',
          value: currFilter.contact ? currFilter.contact.label : null
        },
        { type: 'label', label: 'report.view.taggedWith' },
        {
          type: 'options',
          ident: 'filtertag',
          label: 'report.view.filterAllTags',
          value: tags ? tags.map(tag => tag.label) : []
        }
      ]
    } else if (reportType === 'planner-overview') {
      options.items = [
        { type: 'label', label: 'report.view.headerTitlePlanner' },
        {
          type: 'options',
          ident: 'filterusermulti',
          label: 'report.view.filterAllTeamMembers',
          value: currFilter.users
            ? currFilter.users.map(user => user.label)
            : []
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'option',
          ident: 'filtercontact',
          label: 'report.view.filterAllClients',
          value: currFilter.contact ? currFilter.contact.label : null
        },
        { type: 'label', label: 'report.view.taggedWith' },
        {
          type: 'options',
          ident: 'filtertag',
          label: 'report.view.filterAllTags',
          value: tags ? tags.map(tag => tag.label) : []
        }
      ]
    } else {
      options.items = [
        { type: 'label', label: 'report.view.headerTitleWorkInProgress' },
        {
          type: 'date',
          ident: 'filterdate',
          label: 'report.view.filterToday',
          value: currFilter.dateFilter,
          isDateRange: false
        },
        { type: 'label', label: 'report.view.for' },
        {
          type: 'option',
          ident: 'filtercontact',
          label: 'report.view.filterAllClients',
          value: currFilter.contact ? currFilter.contact.label : null
        },
        { type: 'label', label: 'report.view.taggedWith' },
        {
          type: 'options',
          ident: 'filtertag',
          label: 'report.view.filterAllTags',
          value: tags ? tags.map(tag => tag.label) : []
        }
      ]
    }

    return this.renderFilerPanel(options)
  }

  _renderFilterContact () {
    const currFilter = this._getCurrentFilter()

    const options = {
      placeholder: 'report.view.searchClientPlaceholder',
      keyword: currFilter.keywordContact,
      items: this.data.contactOptions,
      onSearch: this._onSearchContact.bind(this),
      onSelect: this._onChangeContact.bind(this),
      onClose: this._onCloseSearch.bind(
        this,
        'keywordContact',
        'contact',
        'contactOptions',
        'filtermain'
      )
    }

    return this.renderFilerSearchPanel(options)
  }

  _renderFilterTag () {
    const { tagOptions } = this.data
    const currFilter = this._getCurrentFilter()
    const reportType = this.props.reportType

    const options = {
      placeholder: 'report.view.searchTagPlaceholder',
      keyword: currFilter.keywordTag,
      items: tagOptions,
      activeItems: currFilter.tags || [],
      onSearch: this._onSearchTag.bind(this),
      onSelect: this._onSelectTag.bind(this),
      onRemoveTag: this._onRemoveTag.bind(this),
      onClose: this._onShowFilter.bind(
        this,
        reportType === 'employee-productivity-v2' ? 'main' : 'filtermain'
      )
    }

    return this.renderFilterTagPanel(options)
  }

  _renderFilterUserMulti () {
    const { userOptions } = this.data
    const currFilter = this._getCurrentFilter()
    const reportType = this.props.reportType

    const options = {
      placeholder: 'report.view.searchUserPlaceholder',
      keyword: currFilter.keywordUser,
      items: userOptions,
      activeItems: currFilter.users || [],
      onSearch: this._onSearchUser.bind(this, true),
      onSelect: this._onSelectUserMulti.bind(this),
      onRemoveItem: this._onRemoveUserMulti.bind(this),
      onClose: this._onShowFilter.bind(
        this,
        reportType === 'employee-productivity-v2' ? 'main' : 'filtermain'
      )
    }

    return this.renderFilerMultiSearchPanel(options)
  }

  _renderFilterDate () {
    const currFilter = this._getCurrentFilter()
    const date = DateUtil.getUTCCurrentDate()
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const currDay = date.getDate()
    const defaultDateFilterIdent = this._getDefaultActiveDateFilter()

    const options = {
      isRange: false,
      active: currFilter.dateFilter
        ? currFilter.dateFilter.ident
        : defaultDateFilterIdent,
      value: currFilter.dateFilter ? currFilter.dateFilter.value : null,
      filters: [
        {
          ident: 'today',
          label: 'report.view.filterToday',
          value: DateUtil.getUTCDate(currYear, currMonth, currDay)
        },
        {
          ident: 'yesterday',
          label: 'report.view.filterYesterday',
          value: DateUtil.getUTCDate(currYear, currMonth, currDay - 1)
        },
        {
          ident: 'end-of-lastmonth',
          label: 'report.view.filterEndOfLastMonth',
          value: DateUtil.getUTCDate(currYear, currMonth, 0)
        }
      ],
      onChange: this._onChangeDate.bind(this),
      onClose: this._onShowFilter.bind(this, 'filtermain')
    }

    return this.renderFilerDateRangePanel(options)
  }

  _renderFilterEmployeeStatus () {
    const currFilter = this._getCurrentFilter()
    const options = {
      items: [
        { label: 'report.view.filterAll', ident: 'all' },
        { label: 'report.view.filterActive', ident: 'active' },
        { label: 'report.view.filterArchived', ident: 'archived' }
      ],
      active: currFilter.status || 'all',
      onChange: this._onChangeEmployeeStatus.bind(this),
      onClose: this._onShowFilter.bind(this, 'filtermain')
    }

    return this.renderFilterListPanel(options)
  }

  _renderFilterDateRange () {
    const currFilter = this._getCurrentFilter()
    const currYear = DateUtil.getLocalYear()
    const currMonth = DateUtil.getLocalMonth()
    const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
    lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)
    const lastWeekEndDate = new Date(lastWeekStartDate)
    lastWeekEndDate.setDate(lastWeekStartDate.getDate() + 6)

    const defaultDateFilterIdent = this._getDefaultActiveDateFilter()
    const reportType = this.props.reportType

    const options = {
      isRange: true,
      active: currFilter.dateFilter
        ? currFilter.dateFilter.ident
        : defaultDateFilterIdent,
      value: currFilter.dateFilter ? currFilter.dateFilter.value : null,
      filters: [
        {
          ident: 'last-week',
          label: 'report.view.filterLastWeek',
          value: {
            from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
            to: DateUtil.getUTCDateFromTime(lastWeekEndDate)
          }
        },
        {
          ident: 'last-month',
          label: 'report.view.filterLastMonth',
          value: {
            from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
            to: DateUtil.getUTCDate(currYear, currMonth, 0)
          }
        },
        {
          ident: 'last-year',
          label: 'report.view.filterLastYear',
          value: {
            from: DateUtil.getUTCDate(currYear - 1, 0, 1),
            to: DateUtil.getUTCDate(currYear - 1, 11, 31)
          }
        },
        {
          ident: 'this-month',
          label: 'report.view.filterThisMonth',
          value: {
            from: DateUtil.getUTCDate(currYear, currMonth, 1),
            to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
          }
        },
        {
          ident: 'this-year',
          label: 'report.view.filterThisYear',
          value: {
            from: DateUtil.getUTCDate(currYear, 0, 1),
            to: DateUtil.getUTCDate(currYear, 11, 31)
          }
        }
      ],
      onChange: this._onChangeDateRange.bind(this),
      onClose: this._onShowFilter.bind(
        this,
        reportType === 'employee-productivity-v2' ? 'main' : 'filtermain'
      )
    }

    return this.renderFilerDateRangePanel(options)
  }

  _renderFilterProject () {
    const currFilter = this._getCurrentFilter()

    const options = {
      placeholder: 'report.view.searchProjectPlaceholder',
      keyword: currFilter.keywordProject,
      items: this.data.projectOptions,
      onSearch: this._onSearchProject.bind(this),
      onSelect: this._onChangeProject.bind(this),
      onClose: this._onCloseSearch.bind(
        this,
        'keywordProject',
        'project',
        'projectOptions',
        'filtermain'
      )
    }

    return this.renderFilerSearchPanel(options)
  }

  _renderFilterUser () {
    const currFilter = this._getCurrentFilter()

    const options = {
      placeholder: 'report.view.searchUserPlaceholder',
      keyword: currFilter.keywordUser,
      items: this.data.userOptions,
      onSearch: this._onSearchUser.bind(this, false),
      onSelect: this._onChangeUser.bind(this),
      onClose: this._onCloseSearch.bind(
        this,
        'keywordUser',
        'user',
        'userOptions',
        'filtermain'
      )
    }

    return this.renderFilerSearchPanel(options)
  }

  /* Event Handlers */
  _onExport () {
    if (this.props.onExport) {
      this.props.onExport()
    }
  }

  _onShowFilter (panel) {
    this.setState({ currentPanel: panel })
  }

  _onChangeDate (ident, value, label) {
    const currFilter = this._getCurrentFilter()
    if (value) {
      currFilter.dateFilter = { ident, value, label: label || '' }
    } else {
      currFilter.dateFilter = null
    }

    this._onChangeFilter()
  }

  _onChangeDateRange (ident, value, label) {
    const currFilter = this._getCurrentFilter()
    if (value && (value.from || value.to)) {
      currFilter.dateFilter = { ident, value, label: label || '' }
    } else {
      currFilter.dateFilter = null
    }

    this._resetProductivityGraphFilter(currFilter)
    this._onChangeFilter()
  }

  _resetProductivityGraphFilter (currFilter) {
    if (this.props.reportType === 'employee-productivity-v2') {
      const filterType = currFilter.filterType
      let value =
        currFilter.dateFilter && currFilter.dateFilter.value
          ? currFilter.dateFilter.value
          : null
      if (!value) {
        const currYear = DateUtil.getLocalYear()
        const currMonth = DateUtil.getLocalMonth()

        value = {
          from: DateUtil.getUTCDate(currYear, currMonth, 1),
          to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
        }
      }

      const currDate = new Date(value.from || value.to || new Date())
      let graphFromDate = new Date(currDate.getFullYear(), 0, 1)
      let graphToDate = new Date(currDate.getFullYear(), 11, 31, 23, 59, 59)

      if (filterType === 'week') {
        const currWeekNo = DateUtil.getLocalWeekNo(currDate)
        graphFromDate = Util.getMondayByWeek(currDate.getFullYear(), currWeekNo)
        graphFromDate.setHours(0, 0, 0, 0)
        graphToDate = DateUtil.addDaysToDate(graphFromDate, 6)
        graphToDate.setHours(23, 59, 59, 0)
      } else if (filterType === 'month') {
        graphFromDate = new Date(currDate.getFullYear(), currDate.getMonth(), 1)
        graphToDate = new Date(
          currDate.getFullYear(),
          currDate.getMonth() + 1,
          0,
          23,
          59,
          59
        )
      }

      currFilter.graphFromDate = graphFromDate
      currFilter.graphToDate = graphToDate
    }
  }

  _onChangeEmployeeStatus (status) {
    const currFilter = this._getCurrentFilter()
    currFilter.status = status !== 'all' ? status : ''

    this._onShowFilter('filtermain')
    this._onChangeFilter()
  }

  _onDeleteFilter (filterIdent) {
    const currFilter = this._getCurrentFilter()

    if (filterIdent === 'filtercontact') {
      currFilter.contact = null
      currFilter.keywordContact = ''
    } else if (filterIdent === 'filtertag') {
      currFilter.tags = []
      currFilter.keywordTag = ''
    } else if (filterIdent === 'filterproject') {
      currFilter.project = null
      currFilter.keywordProject = ''
    } else if (filterIdent === 'filteruser') {
      currFilter.user = null
      currFilter.keywordUser = ''
    } else if (filterIdent === 'filterusermulti') {
      currFilter.users = []
      currFilter.keywordUser = ''
    } else if (
      filterIdent === 'filterdate' ||
      filterIdent === 'filterdaterange'
    ) {
      currFilter.dateFilter = null
    } else if (filterIdent === 'filteremployee-status') {
      currFilter.status = ''
    }

    this._resetProductivityGraphFilter(currFilter)

    this._onChangeFilter()
  }

  _onSearchContact (keyword) {
    const currFilter = this._getCurrentFilter()
    currFilter.keywordContact = keyword

    if (this.props.onSearchContact) {
      if (this._searchTimeContact) window.clearTimeout(this._searchTimeContact)

      this._searchTimeContact = window.setTimeout(() => {
        this.props.onSearchContact(keyword, options => {
          this.data.contactOptions = options
          this.forceUpdate()
        })
      }, 1000)
    }
  }

  _onChangeContact (contact) {
    const currFilter = this._getCurrentFilter()
    currFilter.contact = contact
    currFilter.keywordContact = contact.label

    this.data.contactOptions = []

    this._onChangeFilter()
  }

  _onSearchProject (keyword) {
    const currFilter = this._getCurrentFilter()
    currFilter.keywordProject = keyword

    if (this.props.onSearchProject) {
      if (this._searchTimeProject) window.clearTimeout(this._searchTimeProject)

      this._searchTimeProject = window.setTimeout(() => {
        this.props.onSearchProject(keyword, options => {
          this.data.projectOptions = options
          this.forceUpdate()
        })
      }, 1000)
    }
  }

  _onChangeProject (project) {
    const currFilter = this._getCurrentFilter()
    currFilter.project = project
    currFilter.keywordProject = project.label

    this.data.projectOptions = []

    this._onChangeFilter()
  }

  _onSearchUser (bMulti, keyword) {
    const currFilter = this._getCurrentFilter()
    currFilter.keywordUser = keyword

    if (this.props.onSearchUser) {
      if (this._searchTimeUser) window.clearTimeout(this._searchTimeUser)

      this._searchTimeUser = window.setTimeout(() => {
        this.props.onSearchUser(keyword, options => {
          // Ignore selected users
          let newOptions = []
          if (bMulti && currFilter.users && currFilter.users.length > 0) {
            options.map(user => {
              if (
                _.findIndex(
                  currFilter.users,
                  existObj => existObj.value === user.value
                ) < 0
              ) {
                newOptions.push(user)
              }
            })
          } else {
            newOptions = options
          }

          this.data.userOptions = newOptions
          this.forceUpdate()
        })
      }, 1000)
    }
  }

  _onChangeUser (user) {
    const currFilter = this._getCurrentFilter()
    currFilter.user = user
    currFilter.keywordUser = user.label

    this.data.userOptions = []

    this._onChangeFilter()
  }

  _onSearchTag (keyword) {
    const currFilter = this._getCurrentFilter()
    currFilter.keywordTag = keyword

    if (this.props.onSearchTag) {
      if (this._searchTimeTag) window.clearTimeout(this._searchTimeTag)

      this._searchTimeTag = window.setTimeout(() => {
        this.props.onSearchTag(keyword, options => {
          this.data.tagOptions = options
          this.forceUpdate()
        })
      }, 1000)
    }
  }

  _onSelectTag (tag) {
    const currFilter = this._getCurrentFilter()
    currFilter.tags.push(tag)
    currFilter.keywordTag = ''
    this.data.tagOptions = []

    this._onChangeFilter()
  }

  _onRemoveTag (tag) {
    const currFilter = this._getCurrentFilter()
    _.remove(currFilter.tags, obj => obj.value === tag)
    this._onChangeFilter()
  }

  _onSelectUserMulti (user) {
    const currFilter = this._getCurrentFilter()
    currFilter.users.push(user)
    currFilter.keywordUser = ''
    this.data.userOptions = []

    this._onChangeFilter()
  }

  _onRemoveUserMulti (user) {
    const currFilter = this._getCurrentFilter()
    _.remove(currFilter.users, obj => obj.value === user.value)
    this._onChangeFilter()
  }

  _onChangeFilter () {
    if (this.props.onChangeFilter) {
      const {
        workInProgress,
        closedProjects,
        employeeProductivity,
        timeRegistration,
        plannerOverview,
        closedProjectsV2,
        employeeProductivityV2
      } = this.data
      this.props.onChangeFilter({
        workInProgress,
        closedProjects,
        employeeProductivity,
        timeRegistration,
        plannerOverview,
        closedProjectsV2,
        employeeProductivityV2
      })
    }
  }

  _onCloseSearch (keywordName, valueName, optionsName, nextPanel) {
    const currFilter = this._getCurrentFilter()
    const reportType = this.props.reportType

    if (!currFilter[keywordName]) {
      currFilter[valueName] = null
      this._onChangeFilter()
    }

    if (currFilter[valueName]) {
      currFilter[keywordName] = currFilter[valueName].label
    }

    this.data[optionsName] = []
    if (reportType === 'employee-productivity-v2') {
      this._onShowFilter('main')
    } else {
      this._onShowFilter(nextPanel || 'filtermain')
    }
  }

  _onChangePlannerFilter (filter) {
    this.data.plannerOverview = filter
    this.setState({ isFilterActive: true, dateDate: new Date() })
    this._onChangeFilter()
  }

  _onChangeEmpProductivityFilter (filter) {
    this.data.employeeProductivityV2 = this.data.employeeProductivityV2 || {}
    Object.assign(this.data.employeeProductivityV2, filter)

    this.setState({ isFilterActive: true, dateDate: new Date() })
    this._onChangeFilter()
  }

  _getCurrentFilter () {
    const reportType = this.props.reportType

    let filterName = 'workInProgress'
    if (reportType === 'closed-projects') {
      filterName = 'closedProjects'
    } else if (reportType === 'employee-productivity') {
      filterName = 'employeeProductivity'
    } else if (reportType === 'time-registration') {
      filterName = 'timeRegistration'
    } else if (reportType === 'closed-projects-v2') {
      filterName = 'closedProjectsV2'
    } else if (reportType === 'employee-productivity-v2') {
      filterName = 'employeeProductivityV2'
    } else if (reportType === 'planner-overview') {
      filterName = 'plannerOverview'
    }

    return this.data[filterName]
  }

  _initDataFromPageState (filterRes) {
    if (!filterRes) return

    if (filterRes.workInProgress) {
      const filter = filterRes.workInProgress
      this.data.workInProgress = {
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordTag: '',
        contact: filter.contact || null,
        dateFilter: filter.dateFilter || null,
        tags: filter.tags || []
      }
    }

    if (filterRes.closedProjects) {
      const filter = filterRes.closedProjects
      this.data.closedProjects = {
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordTag: '',
        contact: filter.contact || null,
        dateFilter: filter.dateFilter || null,
        tags: filter.tags || []
      }
    }

    if (filterRes.closedProjectsV2) {
      const filter = filterRes.closedProjectsV2
      this.data.closedProjectsV2 = {
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordTag: '',
        contact: filter.contact || null,
        dateFilter: filter.dateFilter || null,
        tags: filter.tags || []
      }
    }

    if (filterRes.employeeProductivity) {
      const filter = filterRes.employeeProductivity
      this.data.employeeProductivity = {
        status: filter.status || '',
        dateFilter: filter.dateFilter || null
      }
    }

    if (filterRes.employeeProductivityV2) {
      const filter = filterRes.employeeProductivityV2
      this.data.employeeProductivityV2 = {
        keywordProject: (filter.project && filter.project.label) || '',
        keywordUser: '',
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordTag: '',
        project: filter.project || null,
        users: filter.users || [],
        contact: filter.contact || null,
        dateFilter: filter.dateFilter || null,
        tags: filter.tags || [],
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        graphFromDate: filter.graphFromDate,
        graphToDate: filter.graphToDate,
        filterType: filter.filterType
      }
    }

    if (filterRes.timeRegistration) {
      const filter = filterRes.timeRegistration
      this.data.timeRegistration = {
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordProject: (filter.project && filter.project.label) || '',
        keywordUser: (filter.user && filter.user.label) || '',
        keywordTag: '',
        user: filter.user || null,
        project: filter.project || null,
        contact: filter.contact || null,
        dateFilter: filter.dateFilter || null,
        tags: filter.tags || []
      }
    }

    if (filterRes.plannerOverview) {
      const filter = filterRes.plannerOverview
      this.data.plannerOverview = {
        keywordContact: (filter.contact && filter.contact.label) || '',
        keywordUser: '',
        keywordTag: '',
        users: filter.users || [],
        contact: filter.contact || null,
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        filterType: filter.filterType,
        startMonth: filter.startMonth,
        startWeekNo: filter.startWeekNo,
        year: filter.year,
        tags: filter.tags || []
      }
    }
  }

  _hasActiveFilter () {
    const currFilter = this._getCurrentFilter()
    if (
      currFilter.dateFilter ||
      currFilter.contact ||
      currFilter.user ||
      currFilter.project ||
      currFilter.status ||
      (currFilter.tags && currFilter.tags.length > 0) ||
      (currFilter.users && currFilter.users.length > 0)
    ) {
      return true
    }

    return false
  }

  _getDefaultActiveDateFilter () {
    const reportIdent = this.props.reportType
    if (
      reportIdent === 'employee-productivity-v2' ||
      reportIdent === 'planner-overview'
    ) {
      return 'this-month'
    } else if (
      _.findIndex(
        [
          'closed-projects',
          'employee-productivity',
          'time-registration',
          'closed-projects-v2'
        ],
        ident => ident === reportIdent
      ) >= 0
    ) {
      return 'this-month'
    } else {
      // Work in progress
      // Today
      return 'today'
    }
  }
}

export default PageHeaderReportView
